import React, { useState } from "react";
import ShowIcon from "../../assets/eye.png";
import HideIcon from "../../assets/closed-eye.png";
import "./wpl-password-input.css";

export default function WplPasswordInput({
  title,
  value,
  onChanged,
  error,
  placeholder,
  disabled,
  autoComplete,
  ...rest
}) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="wpl-password-input">
      <label className="title-label">
        {title}
        {error && <span className="error"> - {error}</span>}
      </label>
      <div className="password-input-wrapper">
        <input
          type={showPassword ? "text" : "password"}
          value={value}
          onChange={(e) => onChanged(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          autoComplete={autoComplete}
          {...rest}
        />
        <button
          type="button"
          className="password-toggle"
          onClick={() => setShowPassword(!showPassword)}
          tabIndex={-1}
        >
          <img
            src={showPassword ? ShowIcon : HideIcon}
            alt="Toggle Password Visibility"
          />
        </button>
      </div>
    </div>
  );
}

